import ApplicationPage from '@/pages/ApplicationPage'

function App() {
  const params = new URLSearchParams(window.location.search)
  const recordId = params.get('ID')

  return (
    <div className="min-h-screen bg-white">
      <main className="container mx-auto max-w-4xl px-4 pt-12 pb-16">
        <h1 className="mb-6 text-2xl font-light text-gray-800">Credit Application</h1>
        <ApplicationPage recordId={recordId} />
      </main>
    </div>
  )
}

export default App
